interface DiagnosisImageSectionProps {
  titleHigh: string
  titlePrimary: string
  titlePrimaryMobileA: string
  titlePrimaryMobileB: string
  note: string
  imageUrl: string
  imageUrlMobile: string
  imageAlt: string
}

export function DiagnosisImageSection({
  titleHigh,
  titlePrimary,
  titlePrimaryMobileA,
  titlePrimaryMobileB,
  note,
  imageUrl,
  imageUrlMobile,
  imageAlt,
}: DiagnosisImageSectionProps) {
  return (
    <section id="diagnosis" data-marketing-section="" className="w-full bg-qb-bg py-14 lg:py-24 tracking-[-0.6px]">
      <div className="mx-auto max-w-[1136px] px-6 lg:px-0 flex flex-col items-center gap-14 lg:gap-20">
        {/* Title */}
        <h2 className="text-center font-bold text-[28px] lg:text-[40px] leading-[1.4] lg:leading-[1.2]">
          <span className="block text-qb-text-high">{titleHigh}</span>
          <span className="block mt-1 lg:mt-2.5 text-qb-primary">
            <span className="hidden lg:inline">{titlePrimary}</span>
            <span className="lg:hidden">
              {titlePrimaryMobileA}
              <br aria-hidden />
              {titlePrimaryMobileB}
            </span>
          </span>
        </h2>

        {/* Diagram image */}
        <picture className="flex justify-center w-full">
          <source media="(min-width: 1024px)" srcSet={imageUrl} />
          <img
            src={imageUrlMobile}
            alt={imageAlt}
            className="w-full max-w-[312px] lg:max-w-[1136px] h-auto object-contain"
          />
        </picture>

        {/* Note */}
        <p className="font-normal text-qb-text-mid text-[18px] lg:text-[24px] leading-[1.5] lg:leading-[1.4] text-center">
          {note}
        </p>
      </div>
    </section>
  )
}
